import React from "react";
import { Control, FieldErrors } from "react-hook-form";
import { ValidateRule } from "sprint-common-web";

import {
    CrossTypeContentSearch,
    CrossTypeContentSearchItem
} from "../../../../common/components/form/CrossTypeContentSearch";
import { useCreateOrder } from "../common/provider/useCreateOrder";

interface OrderContentTypeSelectorProps {
    label: string;
    name: string;
    control: Control;
    errors: FieldErrors;
    validate?: ValidateRule<string> | undefined;
}

export const OrderContentSelector: React.FC<OrderContentTypeSelectorProps> = ({
    label,
    name,
    control,
    errors,
    validate
}: OrderContentTypeSelectorProps) => {
    const { setContentType, setContentDetails, clearContentVersion, contentDetails } = useCreateOrder();

    const handleContentSelected = (content: CrossTypeContentSearchItem) => {
        clearContentVersion();
        setContentType(content.subtype);
        setContentDetails(content);
    };

    const handleContentUnselected = () => {
        clearContentVersion();
        setContentType(undefined);
        setContentDetails(undefined);
    };

    return (
        <CrossTypeContentSearch
            label={label}
            placeholder="Search and select content"
            name={name}
            control={control}
            errors={errors}
            initOptions={contentDetails ? [{ key: contentDetails.id, text: contentDetails.title }] : []}
            onSelect={handleContentSelected}
            onClear={handleContentUnselected}
            testId="order-content-selector"
            required={true}
            validate={validate}
        />
    );
};
